require('./accountLastMovementsHeader.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { formatText } = require('core/i18n').i18n;

// @commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');

class AccountLastMovementsHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { onFilterClick, downloadButton } = this.props;

        let headerTitle = (
            <div>
                {formatText('accountMovements-movementsTitle')}
            </div>
        );

        return (
            <header className="account-last-movements-header">
                <div className="account-last-movements-header__title">
                    <OKBoxTitle value={headerTitle} />
                </div>
                <div className="account-last-movements-header__filters">
                    <OKButton
                        id="btn_accountLastMovementsHeader_filterButton"
                        modifier="task"
                        onClick={onFilterClick}
                    >
                        <i className="icon icon-filtrar account-last-movements-header__filter-settings-icon" />
                    </OKButton>
                    {downloadButton}
                </div>
            </header>
        );
    }
}

AccountLastMovementsHeader.propTypes = {
    immFilter: PropTypes.object,
    onFilterClick: PropTypes.func.isRequired,
    downloadButton: PropTypes.object
}

module.exports = AccountLastMovementsHeader;